import axios from 'axios';
import consts from '../consts';
import { setErroAPI } from '../common/toast/toast';

const parametrosFiltro = (filtro = {}) => ({
	id_cooperativa: filtro.id_cooperativa || null,
	id_empresa: filtro.id_empresa || null,
	id_turma: filtro.id_turma || null
});

const parametrosRelatorio = (filtro = {}) => ({
	...parametrosFiltro(filtro),
	tipo: filtro.tipo || null,
	ano: filtro.ano || null,
	mes: filtro.mes || null
});

export function getListaCooperativa() {
    const request = axios.get(`${consts.API_URL}/cooperativa/listarSelect`);
    return {
        type: 'DASHBOARD_COOPERATIVA_SELECT_LISTADO',
        payload: request
    };
}

export function getListaEmpresa() {
    const request = axios.get(`${consts.API_URL}/empresa/listarSelect`);
    return {
        type: 'DASHBOARD_EMPRESA_SELECT_LISTADO',
        payload: request
    };
}

export function getListaTurma() {
    const request = axios.get(`${consts.API_URL}/turma/listarSelect`);
    return {
        type: 'DASHBOARD_TURMA_SELECT_LISTADO',
        payload: request
    };
}

export function getListaPorCooperativa(filtro = {}) {
    const request = axios.get(`${consts.API_URL}/funcionario/listarPorCooperativa`, { params: parametrosFiltro(filtro) });
    return {
        type: 'DASHBOARD_LISTADO_COOPERATIVA',
        payload: request
    };
}

export function getListaPorEmpresa(filtro = {}) {
    const request = axios.get(`${consts.API_URL}/funcionario/listarPorEmpresa`, { params: parametrosFiltro(filtro) });
    return {
        type: 'DASHBOARD_LISTADO_EMPRESA',
        payload: request
    };
}

export function getListaPorTurma(filtro = {}) {
    const request = axios.get(`${consts.API_URL}/funcionario/listarPorTurma`, { params: parametrosFiltro(filtro) });
    return {
        type: 'DASHBOARD_LISTADO_TURMA',
        payload: request
    };
}

export function getListaPorFuncionario(filtro = {}) {
    const request = axios.get(`${consts.API_URL}/funcionario/listarPorFuncionario`, { params: parametrosFiltro(filtro) });
    return {
        type: 'DASHBOARD_LISTADO_FUNCIONARIO',
        payload: request
    };
}

export function getListaRelatorioPresencaPorEmpresa(filtro) {

	return dispatch => {
		dispatch({
			type: 'FUNCIONARIO_RELATORIO_PRESENCA_POR_EMPRESA_LISTADO',
			payload: { data: [] }
		});

	    axios.get(`${consts.API_URL}/funcionario/listarRelatorioPresencaPorEmpresa`, { params: parametrosRelatorio(filtro) })
		.then(resp => {
			dispatch({
				type: 'FUNCIONARIO_RELATORIO_PRESENCA_POR_EMPRESA_LISTADO',
				payload: resp
			});
		}).catch(ex => {
			if (ex && ex.response) setErroAPI(ex);
		});
	}
}
export function getListaRelatorioPresencaPorCooperativa(filtro) {

	return dispatch => {
		dispatch({
			type: 'FUNCIONARIO_RELATORIO_PRESENCA_POR_COOPERATIVA_LISTADO',
			payload: { data: [] }
		});

	    axios.get(`${consts.API_URL}/funcionario/listarRelatorioPresencaPorCooperativa`, { params: parametrosRelatorio(filtro) })
		.then(resp => {
			dispatch({
				type: 'FUNCIONARIO_RELATORIO_PRESENCA_POR_COOPERATIVA_LISTADO',
				payload: resp
			});
		}).catch(ex => {
			if (ex && ex.response) setErroAPI(ex);
		});
	}
}


export function getListarPorFuncionarioQuantidadeEmpresa(filtro = {}) {

	return dispatch => {
		dispatch({
			type: 'FUNCIONARIO_QUANTIDADE_EMPRESA',
			payload: { data: [] }
		});

	    axios.get(`${consts.API_URL}/funcionario/listarPorFuncionarioQuantidadeEmpresa`, { params: parametrosFiltro(filtro) })
		.then(resp => {
			dispatch({
				type: 'FUNCIONARIO_QUANTIDADE_EMPRESA',
				payload: resp
			});
		}).catch(ex => {
			if (ex && ex.response) setErroAPI(ex);
		});
	}
}
